import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Form, Input, Radio, Row, Select, Space } from "antd";
import { Footer, Header } from "antd/es/layout/layout";
import PageHeading from "../../../../../components/common/PageHeading";
import { addDoc, collection, doc, getDocs, query, where } from "firebase/firestore";
import { auth, db } from "../../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-hot-toast";

const NewInspectionTemplate = () => {
  const [inspectionLayout, setInspectionLayout] = useState(1);
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [inspectionList, setInspectionList] = useState([]);

  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();

  }, [user, loading]);


  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "inspectionsTemplates");
        const snapshot = await getDocs(userRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setInspectionList(
          fetchedData.map((item) => ({
            value: item.id,
            label: item.inspectionName,
          }))
        );
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    };
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setInspectionLayout(e.target.value);
  };


  const handleNewInspection = (id) => {
    navigate(`/inspection/new_inspection_template/${id}`);
  };

  const onFinish = async (values) => {

    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef,companyName);

    try {
      // Create a new collection named "inspections" under the "companyName" document
      const inspectionsCollectionRef = collection(companyDocRef, "inspectionsTemplates");
  
      // Add a new document to the "inspections" collection
      const result = await addDoc(inspectionsCollectionRef, {
        inspectionName: values.inspectionName || "",
        inspectionTemplate: values.inspectionTemplate || "",
        inspectionTemplateName: values.inspectionTemplateName || ""
      });
  
      toast.success("Inspection Template created successfully");
      handleNewInspection(result.id);

    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const defaultValues = {
    inspectionTemplate: 1
  }

  return (
    <div>
      <Header>
        <div className="inspection_topHeader" theme="dark">
          <h1 style={{ fontWeight: 400 }}>New Inspection Template</h1>
        </div>
      </Header>

      <Row justify="center">
        <Col span={12}>
          <PageHeading heading="TEMPLATE INFORMATION" />

          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={defaultValues}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              label="Name"
              name="inspectionName"
              rules={[{ required: true, message: 'Please enter inspection template name' }]}
            >
              <Input />
            </Form.Item>

            <PageHeading heading="TEMPLATE LAYOUT" />
            <Form.Item name="inspectionTemplate">
              <Radio.Group onChange={onChange} value={inspectionLayout}>
                <Space direction="vertical" >
                  <Radio value={1}>Use default layout as starting point.</Radio>
                  <Radio value={2}>
                    Use existing inspection or template as starting point.
                  </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="inspectionTemplateName">
              <Select
                allowClear
                showSearch
                disabled={inspectionLayout === 1 ? true : false}
                placeholder="Search for template, property, tenant or inspection"
                options={inspectionList}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Footer
        style={{
          textAlign: "center",
        }}
      >
        Copyright SayEagle © 2023
      </Footer>
    </div>
  );
};

export default NewInspectionTemplate;
